module.exports = "div.no-payments-message {\n  margin: 15px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/payment/history.component.scss
// module id = ./src/app/payment/history.component.scss
// module chunks = main